import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class TrendMicro extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M2.186,14.291,2.2,14.25l.047-.128.046-.116.021-.053a12.638,12.638,0,0,1,.847-1.7c.044-.095.091-.189.137-.283l-1.437,0,.348-.77A11.285,11.285,0,0,0,7.268,8.39l.056,0h.994L7.032,11.142,9.1,11.136l-.379.82-2.061.007a19.513,19.513,0,0,0-1.3,3.316c-.254,1.544,0,2.7,1.379,3.128a5.506,5.506,0,0,0,3.068-.122,17.239,17.239,0,0,0,7.62-5.1c3.441-4,3.508-8.088.152-9.132-2.153-.669-5.19.075-8,1.749,3.5-2.259,7.355-3.32,10.014-2.493a4.491,4.491,0,0,1,1.3.633A12,12,0,0,0,1.99,18.619a6.075,6.075,0,0,1,.2-4.328" />
        <path d="M22.174,5.634c.8,2.181-.2,5.434-2.973,8.655C15.04,19.128,8.467,22.054,4.522,20.826A4.472,4.472,0,0,1,3.244,20.2a12,12,0,0,0,18.93-14.57" />
      </svg>
    );
  }
}

export default TrendMicro;
